<!-- Wrapper -->
<header></header>
<div id="wrapper">
  <!-- Left navigation bar -->
  <navigation></navigation>
  <!-- Main page wrapper -->
  <!-- <div id="page-wrapper" class="gray-bg"> -->
  <div id="page-wrapper" class="white-bg">
    <!-- Header -->
    <!-- Top navigation -->
    <p-confirmDialog header="{{'General.info' | translate}}" icon="pi pi-exclamation-triangle"
      acceptLabel="{{'General.accept' | translate}}" rejectLabel="{{'General.cancel' | translate}}"></p-confirmDialog>
    <topnavbar style="
    display: block;
    position: fixed;
    z-index: 3;   width: 100%;"></topnavbar>
    <sub-header></sub-header>
    <!-- Main view/routes wrapper -->
    <router-outlet></router-outlet>
    <!-- Footer -->
    <footer></footer>
  </div>
  <!-- End page wrapper -->
</div>
<!-- End wrapper -->